import React from 'react';
import { FormikControl } from '..';

// For Discount Consultation Form Only
export function UserInputs() {
    return (
        <div className="row form-steps-container position-relative overflow-hidden">
            <div className="col form-inputs-wrapper">
                <div className="row gx-2 justify-content-center">
                    <div className="col-6 pt-md-1 pr-1">
                        <FormikControl control="input" name="first_name" placeholder="First Name" type="text" />
                    </div>
                    <div className="col-6 pt-md-1 pl-1">
                        <FormikControl control="input" name="last_name" placeholder="Last Name" type="text" />
                    </div>
                </div>
                <div id="scrollToMessage" className="row justify-content-center mb-2">
                    <div className="mt-2">
                        <FormikControl control="phoneInput" name="phone" placeholder="Phone Number" type="tel" />
                    </div>
                    <div className="mt-2">
                        <FormikControl control="emailInput" name="email" placeholder="Email Address" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserInputs;
